var map = {
	"./fish1.png": "Du8b",
	"./fish10.png": "KFCT",
	"./fish11.png": "ysjW",
	"./fish12.png": "B6M3",
	"./fish13.png": "/dDD",
	"./fish14.png": "DIeu",
	"./fish15.png": "9zS+",
	"./fish16.png": "SH/9",
	"./fish17.png": "P6hf",
	"./fish18.png": "T8cX",
	"./fish19.png": "/fVG",
	"./fish2.png": "i2yW",
	"./fish20.png": "PDge",
	"./fish21.png": "NZmt",
	"./fish22.png": "4lu5",
	"./fish23.png": "Ol6L",
	"./fish24.png": "F851",
	"./fish25.png": "bxV5",
	"./fish26.png": "S5s/",
	"./fish27.png": "PxSy",
	"./fish28.png": "Vsoy",
	"./fish29.png": "tFqy",
	"./fish3.png": "GW9p",
	"./fish30.png": "jbqc",
	"./fish31.png": "oLVC",
	"./fish32.png": "p23W",
	"./fish33.png": "IlGV",
	"./fish4.png": "wvGc",
	"./fish5.png": "S2zl",
	"./fish6.png": "18tD",
	"./fish7.png": "js5y",
	"./fish8.png": "qIC2",
	"./fish9.png": "nSAO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dYGg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish ^\.\/fish.*\.png$
// module id = dYGg
// module chunks = 0